export const isMobile = (): boolean => {
  return /Android|iPhone|iPad/i.test(navigator.userAgent) && 'ontouchend' in document;
};
